import { render, staticRenderFns } from "./EbCargoInfo.vue?vue&type=template&id=411ec488&scoped=true&"
import script from "./EbCargoInfo.vue?vue&type=script&lang=js&"
export * from "./EbCargoInfo.vue?vue&type=script&lang=js&"
import style0 from "./EbCargoInfo.vue?vue&type=style&index=0&id=411ec488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411ec488",
  null
  
)

export default component.exports